<template lang="html">
  <div class="admin-cancellations-wrapper">
    <div class="title">
      <span>{{$t('competitions.works.work')}}</span>
      <div class="time-wrapper">
        <dropdown
          :defaultText="$t('competitions.main.competition')"
          :selected="competition"
          :list="competitionList"
          @changeOption="competition = $event"
          :removable="true"
          @remove="competition = null"
        />
        <input
          @keyup="getWorks(), (page = 1)"
          v-model="search"
          type="text"
          placeholder="search"
          name=""
          value=""
        />
      </div>
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>{{ $t('competitions.works.wrk_name') }}</td>
            <td>{{ $t('competitions.works.wrk_author') }}</td>
            <td>{{ $t('competitions.works.cmp_name') }}</td>
            <td>{{ $t('competitions.tr.institutionName') }}</td>
            <td>{{ $t('competitions.tr.poens') }}</td>
            <td>{{ $t('competitions.tr.controllVote') }}</td>
            <td>{{ $t('competitions.tr.deleted') }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="work in works" :key="work.wrk_id">
            <td>{{ work.wrk_name }}</td>
            <td>{{ work.wrk_author }}</td>
            <td>{{ work.cmp_name }}</td>
            <td>{{ work.sch_name }}</td>
            <td>
              {{
                parseInt(work.total_points) + parseInt(work.wrk_admin_points)
              }}
            </td>
            <td>{{ work.wrk_admin_points }}</td>
            <td>{{ work.wrk_deleted }}</td>
            <td v-if="!work.wrk_deleted">
              <div @click="openConfirmationModal(work)" class="btn">
                {{$t('competitions.main.delete')}}
              </div>
            </td>
            <td v-else></td>
            <td>
              <div @click="openPointsModal(work)" class="btn">
                {{$t('competitions.main.analysis')}}
              </div>
            </td>
            <td>
              <div
                @click="openCompetitionWorkInfoModal(work)"
                class="icon-wrapper"
              >
                <img
                  :title="$t('main.moreInfo')"
                  src="@/assets/icons/options.png"
                  alt="preview icon"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="works.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/dropdown.vue'
import Paginate from 'vuejs-paginate'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminCancellations',
  components: {
    Paginate,
    Dropdown
  },
  data () {
    return {
      works: [],
      page: 1,
      pageCount: 0,
      search: null,
      dateFrom: null,
      dateTo: null,
      competition: null,
      competitionList: []
    }
  },
  mounted () {
    this.getWorks()
    this.getCompetitions()
  },
  methods: {
    openCompetitionWorkInfoModal (work) {
      let params = {
        modalData: work,
        component: 'competitionWorkInfo'
      }
      eventBus.$emit('openModal', params)
    },
    openPointsModal (work) {
      let modalData = {
        title: this.$t('competitions.main.analysisVoute'),
        points: work.wrk_admin_points,
        ok: points => {
          this.editWork(work, points)
        }
      }
      let params = {
        modalData: modalData,
        component: 'editWorkPoints'
      }
      eventBus.$emit('openModal', params)
    },
    async editWork (work, points) {
      console.log(work, points)
      let params = {
        id: work.wrk_id,
        points: points
      }
      try {
        await api.editWork(params)
        this.$toast.success(this.$t('competitions.tr.successChangeWork'), {
          duration: 8000
        })
      } catch (e) {
        this.$toast.error(this.$t('competitions.tr.error'), {
          duration: 8000
        })
      } finally {
        this.getWorks()
      }
    },
    async getCompetitions () {
      try {
        let res = await api.getAllCompetitions()
        let competitionList = []
        for (var i = 0; i < res.data.data.length; i++) {
          competitionList.push({
            value: res.data.data[i].cmp_id,
            label: res.data.data[i].cmp_name
          })
        }
        this.competitionList = competitionList
      } catch (e) {
        console.log(e)
      }
    },
    getWorks () {
      let params = {
        page: this.page
      }
      if (this.search && this.search !== '') {
        params.search = this.search
      }
      if (this.competition && this.competition.value !== null) {
        params.cmp_id = this.competition.value
      }

      api
        .getWorks(params)
        .then(res => {
          this.works = res.data.data
          this.pageCount = res.data.page_count
        })
        .catch(e => {
          console.log(e)
        })
    },
    open (user) {
      let modalData = {
        title: this.$t('competitions.main.listRejections'),
        user: user,
        start: this.dateFrom,
        end: this.dateTo
      }
      let params = {
        modalData: modalData,
        component: 'userCancellations'
      }
      eventBus.$emit('openModal', params)
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.getWorks()
    },
    openConfirmationModal (work) {
      let modalData = {
        title: this.$t('competitions.main.deleteWork'),
        ok: () => {
          this.deleteWork(work)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    async deleteWork (work) {
      let params = {
        id: work.wrk_id
      }
      try {
        await api.deleteWork(params)
        this.$toast.success(this.$t('competitions.tr.sucessDelete'), {
          duration: 8000
        })
      } catch (e) {
        console.log(e)
        this.$toast.error(this.$t('competitions.tr.errDelete'), {
          duration: 8000
        })
      } finally {
        this.getWorks()
      }
    }
  },
  watch: {
    competition: function (val) {
      this.getWorks()
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-cancellations-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 140px);
    overflow: auto;
  }

  .title {
    margin-bottom: 40px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .time-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;

      * {
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }

    input {
      border: none;
      border-bottom: 1px solid #ddd;
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 20px;
      line-height: 20px;
      padding-right: 20px;
      font-weight: bold;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: $text-color;
      max-width: 230px;
    }
    input:focus {
      outline: none;
    }
  }
}
.icon-wrapper img {
  height: 20px;
}
</style>
